/*=========================================================================================
  File Name: moduleResourceActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	addResource({commit}, resource) {
		return new Promise((resolve, reject) => {
			Api.post("/resource", resource)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchResourceById({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.get(`/resource/${resourceId}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	fetchResourceFilterById({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 10,
				id: data.ids || [],
				status_id: [],
				category_id: [],
				name: data.name || [],
				lastname: data.lastname || [],
				username: data.username || [],
				identification: data.identification || [],
				email: data.email || [],
				imei: data.imei || [],
				additional_info: data.additional_info || [],
				order_by: data.order_by || ["name"],
				sort: data.sort || "desc",
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	updateResource({commit}, resource) {
		return new Promise((resolve, reject) => {
			Api.put(`/resource/${resource.id}`, resource.items)
				.then((response) => {
					commit("UPDATE_RESOURCE", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeResource({commit}, resourceId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/resource/${resourceId}`)
				.then((response) => {
					commit("REMOVE_RESOURCE", resourceId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchResourceFilterPaginate({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				id: data.ids || [],
				status_id: [],
				name: data.name || [],
				lastname: data.lastname || [],
				username: data.username || [],
				identification: data.identification || [],
				email: data.email || [],
				role_id: data.role_id || [],
				role_name: data.role_name || [],
				company_id: data.company_id || [],
				additional_info: data.additional_info || [],
				exist_in_vehicle: data.exist_in_vehicle || [],
				match_filter: data.match_filter,
				order_by: data.order_by || ["name"],
				sort: data.sort || "desc",
			};
			Api.post("/resource/filter", payload)
				.then((res) => {
					commit("SET_RESOURCES", res.data.records);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	removeAssignedResource({commit}, resourceItem) {
		commit("REMOVE_ASSIGNED_RESOURCE", resourceItem);
	},
	currentResourceSelected({commit}, resource) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_RESOURCE", resource);
			resolve(resource);
		});
	},
	setSelectedResource({commit}, data) {
		commit("SET_SELECTED_RESOURCE", data);
	},
};
